(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  class CartUpsellRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      this.list = this.querySelector('[data-cart-upsell-products]');
      this.limit = Math.max(1, Number(this.dataset.limit) || 4);
      this.cartProductIds = new Set(String(this.dataset.productIds || '').split(',').filter(Boolean));
      this.fallbackCards = this.list ? Array.from(this.list.children) : [];
      if (!this.list || !this.dataset.productId) return;
      this.load();
    }

    rootPath() {
      return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    }

    recommendationUrl(intent) {
      return this.rootPath() +
        'recommendations/products?product_id=' + encodeURIComponent(this.dataset.productId) +
        '&intent=' + encodeURIComponent(intent) +
        '&limit=10&section_id=fbt-data';
    }

    parseProducts(text) {
      var container = document.createElement('div');
      container.innerHTML = text;
      var data = container.querySelector('[data-fbt-products]');
      if (!data) return [];
      try {
        return JSON.parse(data.textContent.trim());
      } catch (error) {
        return [];
      }
    }

    fetchIntent(intent) {
      return fetch(this.recommendationUrl(intent), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function (response) {
          if (!response.ok) throw new Error('recommendations');
          return response.text();
        })
        .then(this.parseProducts.bind(this))
        .catch(function () { return []; });
    }

    load() {
      var primary = this.dataset.intent || 'related';
      var intents = primary === 'related' ? ['related', 'complementary'] : ['complementary', 'related'];
      Promise.all(intents.map(this.fetchIntent.bind(this))).then(function (responses) {
        var seen = new Set(this.cartProductIds);
        var products = [];
        responses.flat().forEach(function (product) {
          var productId = String(product.productId || '');
          if (!product.available || !product.id || !productId || seen.has(productId)) return;
          seen.add(productId);
          products.push(product);
        });
        this.render(products.slice(0, this.limit));
      }.bind(this));
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(this.dataset.locale || 'pt-BR', {
          style: 'currency',
          currency: this.dataset.currency || 'BRL',
        }).format(Number(cents || 0) / 100);
      } catch (error) {
        return 'R$ ' + (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
      }
    }

    card(product) {
      var compare = Number(product.compare || 0);
      var price = Number(product.price || 0);
      return '<article class="lfc-cart-upsell__product" data-upsell-product-id="' + escapeHtml(product.productId) + '">' +
        '<a class="lfc-cart-upsell__image-link" href="' + escapeHtml(product.url) + '" tabindex="-1" aria-hidden="true">' +
          (product.image ? '<img class="lfc-cart-upsell__image" src="' + escapeHtml(product.image) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="lfc-cart-upsell__content">' +
          (this.dataset.badge ? '<span class="lfc-cart-upsell__badge">' + escapeHtml(this.dataset.badge) + '</span>' : '') +
          '<a class="lfc-cart-upsell__title" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
          '<div class="lfc-cart-upsell__prices"><span class="lfc-cart-upsell__price">' + this.money(price) + '</span>' +
            (compare > price ? '<s class="lfc-cart-upsell__compare">' + this.money(compare) + '</s>' : '') +
          '</div>' +
        '</div>' +
        '<button class="lfc-cart-upsell__action" type="button" data-cart-upsell-add data-variant-id="' + escapeHtml(product.id) + '" aria-label="' + escapeHtml(this.dataset.buttonLabel + ': ' + product.title) + '">' + escapeHtml(this.dataset.buttonLabel || 'Adicionar') + '</button>' +
      '</article>';
    }

    render(products) {
      if (!products.length) return;
      this.list.innerHTML = products.map(this.card.bind(this)).join('');
      var used = new Set(this.cartProductIds);
      products.forEach(function (product) { used.add(String(product.productId)); });
      var count = products.length;
      this.fallbackCards.forEach(function (card) {
        var productId = String(card.dataset.upsellProductId || '');
        if (count >= this.limit || !productId || used.has(productId)) return;
        used.add(productId);
        this.list.appendChild(card);
        count += 1;
      }.bind(this));
    }
  }

  if (!customElements.get('cart-upsell-recommendations')) {
    customElements.define('cart-upsell-recommendations', CartUpsellRecommendations);
  }
})();
